/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_fr_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Multiply the first fraction by the reciprocal (flip) of the second, then simplify. Dividing by 1/4 is the same as multiplying by 4.`)
};

const es_fr_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Multiplica la primera fracción por el recíproco (invertido) de la segunda y luego simplifica. Dividir entre 1/4 es lo mismo que multiplicar por 4.`)
};

const de_fr_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Multipliziere den ersten Bruch mit dem Kehrwert des zweiten und kürze anschließend. Eine Division durch 1/4 entspricht einer Multiplikation mit 4.`)
};

const nl_fr_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vermenigvuldig de eerste breuk met het omgekeerde van de tweede en vereenvoudig daarna. Delen door 1/4 is hetzelfde als vermenigvuldigen met 4.`)
};

const fr_fr_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Multipliez la première fraction par l'inverse (retournée) de la seconde, puis simplifiez. Diviser par 1/4 revient à multiplier par 4.`)
};

const it_fr_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Moltiplica la prima frazione per il reciproco (capovolto) della seconda, poi semplifica. Dividere per 1/4 equivale a moltiplicare per 4.`)
};

const pt_br2_fr_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Multiplique a primeira fração pelo inverso (invertido) da segunda e depois simplifique. Dividir por 1/4 é o mesmo que multiplicar por 4.`)
};

const pt_fr_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Multiplique a primeira fração pelo inverso (troque numerador e denominador) da segunda e depois simplifique. Dividir por 1/4 é o mesmo que multiplicar por 4.`)
};

const ja_fr_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1つ目の分数に、2つ目の分数の逆数(分子と分母を入れ替えたもの)を掛けてから約分します。1/4で割ることは4を掛けることと同じです。`)
};

const zh_fr_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`将第一个分数乘以第二个分数的倒数，再化简。除以 1/4 等同于乘以 4。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const fr_faq_a2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.fr_faq_a2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("fr_faq_a2", locale)
	if (locale === "en") return en_fr_faq_a2(inputs)
	if (locale === "es") return es_fr_faq_a2(inputs)
	if (locale === "de") return de_fr_faq_a2(inputs)
	if (locale === "nl") return nl_fr_faq_a2(inputs)
	if (locale === "fr") return fr_fr_faq_a2(inputs)
	if (locale === "it") return it_fr_faq_a2(inputs)
	if (locale === "pt-BR") return pt_br2_fr_faq_a2(inputs)
	if (locale === "pt") return pt_fr_faq_a2(inputs)
	if (locale === "ja") return ja_fr_faq_a2(inputs)
	return zh_fr_faq_a2(inputs)
};